import script from "./User.vue?vue&type=script&setup=true&lang=ts"
export * from "./User.vue?vue&type=script&setup=true&lang=ts"

import "./User.vue?vue&type=style&index=0&id=19f5c104&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19f5c104"]])

export default __exports__